import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { useState } from "react";
import { Button } from "primereact/button";

const SearchInputText = (props) => {
  const {
    loading,
    value,
    onChange,
    placeholder,
    onClick,
    onSearch,
    autofocus = true,
  } = props;

  const [showConfirmButton, setShowConfirmButton] = useState(false);

  return (
    <div className="row-start-center w-full gap-2">
      <IconField className="w-full" iconPosition="left">
        <InputIcon
          className={loading ? `pi pi-spin pi-spinner` : `pi pi-search`}
        />
        <InputText
          className="w-full !pl-10"
          autoFocus={autofocus}
          autoComplete="off"
          variant="filled"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSearch(value);
            }
          }}
          pt={{ input: { className: "pl-2" } }}
          onFocus={() => {
            if (onClick) {
              onClick();
            } else {
              setShowConfirmButton(true);
            }
          }}
          onBlur={() => {
            setTimeout(() => setShowConfirmButton(false), 300);
          }}
        />
      </IconField>
      {showConfirmButton && (
        <Button
          className="max-h-[2.2rem] max-w-[2.2rem]"
          rounded
          icon="pi pi-check"
          loading={loading}
          onClick={() => onSearch(value)}
        />
      )}
    </div>
  );
};

export default SearchInputText;
